module.exports = __webpack_public_path__ + "dingbeauty/admin/img/person_background.5969a58d.svg";